import { CurrencyPipe } from '@angular/common';
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { SortEvent } from 'primeng/api';
import { ListaBase } from '../../../shared/crud/ListaBase';
import { ConversaoLibraConverte } from '../../../shared/conversao-libra/conversao-libra-converte';
import { Filtros } from '../../../shared/crud/Filtro/Filtros';
import { DealerItem } from './analise-garantia.model';
import { ExportExcelService } from '../../../shared/excel-service/export-excel.service';
import { FiltroService } from '../../../shared/filtro/filtro.service';
import { AnaliseGarantiaModel } from './analise-garantia.model';
import { AnaliseGarantiaService } from './analise-garantia.service';
import { RetornoSelecao } from '../../../shared/gridview/RetornoSelecao';
import { FiltroDealers } from './filtro-dealer';

@Component({
  selector: 'app-analise-garantia',
  templateUrl: './analise-garantia.component.html',
  styleUrls: ['./analise-garantia.component.css']
})
export class AnaliseGarantiaComponent extends ListaBase implements OnInit {
  //Columns
  subscription;
  columns: any[];
  _selectedColumns: any[];
  loading = false;
  data: AnaliseGarantiaModel[] = [];
  @Input() filtros: any;
  dealers = [];
  selectedDealer: any;
  selecionados = [];
  display: boolean = false;
  filterName: any[];
  nomeModulo: string;
  idOs: any;
  displayFiltrosDealers: boolean = false;
  displayAnalise: boolean = false;
  analiseEtapa: 'escolha' | 'rejeicao' | 'final' = 'escolha';
  mensagemRejeicao: string = '';
  registroSelecionado: any = null;
  filtroDealers: FiltroDealers;
  data_inicial: Date;
  data_final: Date;
  status_os: any = '';
  status = [];
  filtroAtivo: 'pendentes' | 'aprovadas' | 'rejeitadas' | 'todas' = 'pendentes';
  subAbaAprovadas: 'emPagamento' | 'pagas' | null = null;
  usuarioPodeAnalisar: boolean = false;
  paginaAtual: number = 0;
  first: number = 0;

  private readonly CACHE_KEY_SUB_ABA = 'analiseGarantia_subAbaAprovadas';

  dadosTranslate = {}

  constructor(
    service: AnaliseGarantiaService,
    toastr: ToastrService,
    router: Router,
    private filtroService: FiltroService,
    private currency: CurrencyPipe,
    private exportExcelService: ExportExcelService,
    private conversaoLibraConverte: ConversaoLibraConverte,
    private translate: TranslateService,
    private cdRef: ChangeDetectorRef,
    private servico: AnaliseGarantiaService) {
    super(service, toastr, router);
    this.filtros = {};
    this.nomeModulo = 'analise-garantia';
    this.filtroDealers = new FiltroDealers();
  }
//ss
  ngOnInit() {
    this.definirDatasPadrao();
    this.preencherStatus();
    this.verificarPermissaoAnalise();
    this.getAll();
    this.changeLanguageValue();
    this.definirColunas();
  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    //restore original order
    this._selectedColumns = this.columns.filter(col => val.includes(col));
  }

  getAll() {
    this.preencherDealers();
    
    const objFiltro: any = {};
    const dealersSelecionados = this.filtroDealers.selecionados();
    if (dealersSelecionados && dealersSelecionados.length > 0) { 
      objFiltro.dealers = dealersSelecionados.map(d => d.id); 
    }
    if (this.filtros.numero !== undefined && this.filtros.numero !== null && this.filtros.numero !== '') { objFiltro.numero = this.filtros.numero; }
    if (this.filtros.chassi) { objFiltro.chassi = this.filtros.chassi; }
    if (this.data_inicial) { objFiltro.data_inicial = this.formatarDataParaAPI(this.data_inicial); }
    if (this.data_final) { objFiltro.data_final = this.formatarDataParaAPI(this.data_final); }

    // Adicionar filtro de status baseado no filtro ativo
    switch (this.filtroAtivo) {
      case 'pendentes':
        objFiltro.status = 1;
        break;
      case 'aprovadas':
        if (this.subAbaAprovadas === 'pagas') {
          objFiltro.status = 4;
        } else {
          objFiltro.status = 2;
        }
        break;
      case 'rejeitadas':
        objFiltro.status = 3;
        break;
      case 'todas':
        break;
    }

    // status_os: 0 = O.S. aberta, 1 = O.S. fechada; sem valor = comportamento atual
    if (this.status_os !== undefined && this.status_os !== null && this.status_os !== '') {
      objFiltro.status_os = this.status_os;
    }

    this.loading = true
    this.servico.buscar(objFiltro).then(res => {
      this.data = res.dados?.map(dados => {
        if (dados && typeof dados.valor === 'number') {
          dados.valor = this.conversaoLibraConverte.conversaoLibra(dados.valor, null, null);
        }
        
        if (dados && typeof dados.valor_pagamento === 'number') {
          dados.valor_pagamento = this.conversaoLibraConverte.conversaoLibra(dados.valor_pagamento, null, null);
        }
        
        if (dados) {
          dados.data_analise = this.tratarDataGenerica(dados.data_analise);
          dados.data_emissao = this.tratarDataGenerica(dados.data_emissao);
          dados.data_liberacao = this.tratarDataGenerica(dados.data_liberacao);
          dados.data_fechamento = this.tratarDataGenerica(dados.data_fechamento);
          dados.data_venda = this.tratarDataGenerica(dados.data_venda);
          dados.data_entrega = this.tratarDataGenerica(dados.data_entrega);
          dados.data_ultimo_apontamento = this.tratarDataGenerica(dados.data_ultimo_apontamento);
          dados.data_pagamento = this.tratarDataGenerica(dados.data_pagamento);
          
          dados.motivo_reprovacao = dados.motivo_reprovacao ? dados.motivo_reprovacao.trim() : '';
          dados.status = dados.status || null;
        }
        
        return dados;
      }) || [];

      this.loading = false
    });
    this.display = false
  }

  customSort(event: SortEvent) {
    event.data.sort((data1, data2) => {

      let value1 = data1[event.field];
      let value2 = data2[event.field];
      let result = null;

      if (value1 == null && value2 != null) {
        result = -1;
      } else if (value1 != null && value2 == null) {
        result = 1;
      } else if (value1 == null && value2 == null) {
        result = 0;
      } else if (typeof value1 === 'string' && typeof value2 === 'string') {
        result = value1.localeCompare(value2);
      } else {
        result = (value1 < value2) ? -1 : (value1 > value2) ? 1 : 0;
      }

      return (event.order * result);
    });
  }

  //export Excel
  exportExcel() {
    this.exportExcelService.nomeModulo = this.nomeModulo;
    this.exportExcelService.ExportTOExcelJSON(this.data.map(r => {
      let linha = {};

      this._selectedColumns.forEach(c => {
        linha[this.translateHeader(c.header)] = this.translateField(r[c.field])
      });

      return linha;
    }));
  }

  translateHeader(item) {
    return item;
  }

  translateField(item) {
    return item;
  }

  getTranslate(value) {
    return this.dadosTranslate[value] || value;
  }

  //Dialogs
  showDialog() {
    this.display = true;
  }

  cleanFilter() {
    this.filtros.chassi = null
    this.filtros.numero = null
    this.status_os = '';
    this.filtroDealers.dealers.forEach(dealer => dealer.selecionado = false);
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  protected getListagemComFiltros(): boolean {
    const dealersSelecionados = this.filtroDealers.selecionados();
    return (dealersSelecionados && dealersSelecionados.length > 0)
      || this.filtros.chassi
      || this.filtros.numero
      || this.data_inicial
      || this.data_final
      || (this.status_os !== undefined && this.status_os !== null && this.status_os !== '')
  }

  private preencherDealers() {
    this.filtroService.buscar('dealer')
      .then(res => { 
        this.dealers = res.filtros;
        this.filtroDealers.preencher(res.filtros);
      });
  }

  private changeLanguageValue() {
    this.conversaoLibraConverte.preencher();
    this.subscription = this.translate.onLangChange
      .subscribe((event: LangChangeEvent) => {
        this.definirColunas();
        this.getAll();
      });
  }

  private preencherStatus() {
    this.status = [
      { nome: 'rmpv.detalhado.filtros.statusValores.aberta', valor: 0 },
      { nome: 'rmpv.detalhado.filtros.statusValores.fechada', valor: 1 },
    ];
  }

  private definirColunas() {
    this.translate.get('analiseGarantia.colunas').subscribe(translations => {
     this.columns = [
  { field: 'detalhe', header: '', width: '40px' },
  { field: 'analise', header: '', width: '120px' },

  // Ordem solicitada
  { field: 'numero_os', header: translations.numeroOs || 'Número OS', width: '125px' },
  { field: 'dealer', header: translations.dealer || 'Dealer', width: '300px' },
  { field: 'numero_sg', header: translations.numeroSg || 'Número SG', width: '150px' },
  { field: 'status', header: translations.status || 'Status', width: '150px' },
  { field: 'tipo_os', header: translations.tipoOs || 'Tipo OS', width: '130px' },
  { field: 'modelo', header: translations.modelo || 'Modelo', width: '300px' },
  { field: 'chassi', header: translations.chassi || 'Chassi', width: '170px' },
  { field: 'data_venda', header: translations.dataVenda || 'Data de venda', type: 'date', width: '130px' },
  { field: 'km', header: translations.km || 'KM', width: '100px' },
  { field: 'valor', header: translations.valorTotal || translations.valor || 'Valor total', type: this.currency, arg1: ' ', width: '120px' },
  { field: 'campo_informacao', header: translations.campoInformacao || 'Informação', type: 'text', width: '350px' },

  // Demais campos seguem depois
  { field: 'motivo_reprovacao', header: translations.motivoReprovacao, type: 'text', width: '300px' },
  { field: 'data_analise', header: translations.dataAnalise, type: 'date', width: '130px' },
  { field: 'usuario', header: translations.usuario, width: '300px' },
  { field: 'data_emissao', header: translations.dataEmissao, type: 'date', width: '130px' },
  { field: 'data_ultimo_apontamento', header: translations.dataUltimoApontamento, type: 'date', width: '200px' },
  { field: 'data_liberacao', header: translations.dataLiberacao, type: 'date', width: '130px' },
  { field: 'data_fechamento', header: translations.dataFechamento, type: 'date', width: '130px' },
  { field: 'data_entrega', header: translations.dataEntrega, type: 'date', width: '130px' },
  { field: 'data_pagamento', header: translations.dataPagamento || 'Data Pagamento', type: 'date', width: '150px' },
  { field: 'valor_pagamento', header: translations.valorPagamento || 'Valor Pagamento', type: this.currency, arg1: ' ', width: '150px' },
  { field: 'nf_serv', header: translations.nfServ || 'NF Serviço', width: '150px' },
  { field: 'serie_serv', header: translations.serieServ || 'Série Serviço', width: '150px' },
  { field: 'data_serv', header: translations.dataServ || 'Data Serviço', type: 'date', width: '150px' },
  { field: 'nf_peca', header: translations.nfPeca || 'NF Peça', width: '150px' },
  { field: 'serie_peca', header: translations.seriePeca || 'Série Peça', width: '150px' },
  { field: 'data_peca', header: translations.dataPeca || 'Data Peça', type: 'date', width: '150px' },
  { field: 'numero_prefeitura', header: translations.numeroPrefeitura || 'Número Prefeitura', width: '160px' },
];

      this._selectedColumns = this.columns;
      this.cdRef.detectChanges();
    });
  }

  public visualizar(registros) {
    const retorno: RetornoSelecao = new RetornoSelecao();
    retorno.novoCadastro = false;
    retorno.registro = registros.idOrdemServico;
    this.idOs = retorno.registro;
    this.servico.ver(retorno);
  }

  abrirAnalise(registro: any) {
    this.registroSelecionado = registro;
    this.mensagemRejeicao = '';
    this.analiseEtapa = 'escolha';
    this.displayAnalise = true;
  }

  aprovar() {
    this.processarAnalise('1', null);
  }

  rejeitar() {
    this.analiseEtapa = 'rejeicao';
  }

  confirmarRejeicao() {
    const motivoTrimmed = this.mensagemRejeicao ? this.mensagemRejeicao.trim() : '';
    if (!motivoTrimmed) {
      this.toastr.warning('Por favor, informe o motivo da rejeição.', 'Atenção');
      return;
    }
    this.processarAnalise('2', motivoTrimmed);
  }

  private processarAnalise(acao: string, motivoReprovacao: string | null) {
    const dadosAnalise = {
      idOrdemServico: this.registroSelecionado.idOrdemServico,
      acao: acao,
      idDealer: this.registroSelecionado.id_dealer,
      motivoReprovacao: motivoReprovacao
    };

    this.servico.analisar(dadosAnalise)
      .then(res => {
        this.analiseEtapa = 'final';
        this.toastr.success('Análise processada com sucesso!', 'Sucesso');
        this.getAll();
      })
      .catch(error => {
        console.error('Erro ao processar análise:', error);
        this.toastr.error('Erro ao processar a análise. Tente novamente.', 'Erro');
      });
  }

  isAnalisarBloqueado(row: any): boolean {
    if (!this.usuarioPodeAnalisar) {
      return true;
    }
    
    return row?.status === 1 || row?.status === "1";
  }

  getStatusText(status: any): string {
    if (status === 1 || status === "1") {
      return 'Aprovada';
    } else if (status === 2 || status === "2") {
      return 'Rejeitada';
    } else {
      return 'Pendente';
    }
  }
  

  cancelarAnalise() {
    this.displayAnalise = false;
  }

  fecharAnalise() {
    this.displayAnalise = false;
  }

  voltar() {
    this.idOs = null;
  }

  selecionarDealer() {
    this.displayFiltrosDealers = true;
  }

  removerDealer(dealer: any) {
    dealer.selecionado = false;
  }

  onAdicionarDealerFiltro(dealer: DealerItem) {
    dealer.selecionado = true;
  }

  filtrar() {
    return this.selecionados;
  }

  
  validacao(value1, value2){
    if (value1 == null && value2 != null) {
      return -1;
    } else if (value1 != null && value2 == null) {
      return 1;
    } else if (value1 == null && value2 == null) {
      return 0;
    }
  }

  trackByDealerId(index: number, dealer: any): any {
    return dealer ? dealer.id : index;
  }

  limpaDataInicial(data: Date) {
    const hoje = new Date();
    const inicioDoMes = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
    this.data_inicial = inicioDoMes;
  }

  limpaDataFinal(data: Date) {
    const hoje = new Date();
    this.data_final = hoje;
  }

  private definirDatasPadrao() {
    const hoje = new Date();
    const inicioDoMes = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
    
    this.data_inicial = inicioDoMes;
    this.data_final = hoje;
  }

  private verificarPermissaoAnalise() {
    this.servico.verificarPermissaoUsuario()
      .then(res => {
        this.usuarioPodeAnalisar = res === true;
      })
      .catch(error => {
        console.error('Erro ao verificar permissão do usuário:', error);
        this.usuarioPodeAnalisar = false;
      });
  }

  private formatarDataParaAPI(data: Date): string {
    if (!data) return null;
    
    const ano = data.getFullYear();
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    const dia = String(data.getDate()).padStart(2, '0');
    
    return `${ano}-${mes}-${dia}`;
  }

  /**
   * Converte valor de data (ex: 2025-12-04T11:04:56Z[UTC]) para Date para exibição no template.
   */
  dataParaExibicao(value: any): Date | null {
    if (value == null || value === undefined) return null;
    if (value instanceof Date) return value;
    if (typeof value === 'string') {
      const limpa = value.replace(/\s*\[UTC\]\s*$/i, '').trim();
      if (!limpa) return null;
      const d = new Date(limpa);
      return isNaN(d.getTime()) ? null : d;
    }
    return null;
  }

  private tratarDataGenerica(data: any): Date | null {
    if (!data) return null;
    
    if (data instanceof Date) {
      return data;
    }
    
    if (typeof data === 'string') {
      let dataLimpa = data.replace(/\[UTC\]/g, '');
      
      const formatoBrasileiro = /^(\d{2})\/(\d{2})\/(\d{2}|\d{4})$/;
      const match = dataLimpa.match(formatoBrasileiro);
      
      if (match) {
        const [, dia, mes, ano] = match;
        let anoCompleto = parseInt(ano);
        
        if (ano.length === 2) {
          // Regra: anos <= 50 são 2000+, anos > 50 são 1900+
          anoCompleto = anoCompleto <= 50 ? 2000 + anoCompleto : 1900 + anoCompleto;
        }
        
        const dataConvertida = new Date(anoCompleto, parseInt(mes) - 1, parseInt(dia));
        
        if (!isNaN(dataConvertida.getTime())) {
          return dataConvertida;
        }
      }

      const dataConvertida = new Date(dataLimpa);
      
      if (!isNaN(dataConvertida.getTime())) {
        return dataConvertida;
      } else {
        console.warn('Data inválida recebida do backend:', data);
        return null;
      }
    }
    
    return null;
  }
//ee
  alterarFiltro(filtro: 'pendentes' | 'aprovadas' | 'rejeitadas' | 'todas') {
    this.filtroAtivo = filtro;
    this.paginaAtual = 0;
    this.first = 0;
    if (filtro !== 'aprovadas') {
      this.subAbaAprovadas = null;
    } else {
      const subAbaSalva = this.getSubAbaAprovadasCache();
      this.subAbaAprovadas = subAbaSalva || 'emPagamento';
    }
    this.getAll();
  }

  alterarSubAbaAprovadas(subAba: 'emPagamento' | 'pagas') {
    this.subAbaAprovadas = subAba;
    this.paginaAtual = 0;
    this.first = 0;
    this.setSubAbaAprovadasCache(subAba);
    this.getAll();
  }

  onPageChange(event: any) {
    this.paginaAtual = event.page;
    this.first = event.first;
  }

  onDataInicialChange() {
    if (this.data_inicial && this.data_final && this.data_inicial > this.data_final) {
      const novaDataFinal = new Date(this.data_inicial);
      novaDataFinal.setDate(novaDataFinal.getDate() + 1);
      this.data_final = novaDataFinal;
    }
  }

  onDataFinalChange() {
    if (this.data_inicial && this.data_final && this.data_final < this.data_inicial) {
      const novaDataInicial = new Date(this.data_final);
      novaDataInicial.setDate(novaDataInicial.getDate() - 1);
      this.data_inicial = novaDataInicial;
    }
  }

  private setSubAbaAprovadasCache(subAba: 'emPagamento' | 'pagas'): void {
    try {
      localStorage.setItem(this.CACHE_KEY_SUB_ABA, subAba);
    } catch (error) {
      console.error('Erro ao salvar sub-aba no cache:', error);
    }
  }


  private getSubAbaAprovadasCache(): 'emPagamento' | 'pagas' | null {
    try {
      const subAbaSalva = localStorage.getItem(this.CACHE_KEY_SUB_ABA);
      if (subAbaSalva === 'emPagamento' || subAbaSalva === 'pagas') {
        return subAbaSalva;
      }
    } catch (error) {
      console.error('Erro ao recuperar sub-aba do cache:', error);
    }
    return null;
  }

}